const getters = {
    assemblyData(state){
        return state.assemblyData
    },
    departmentList(state){
        return state.departmentList
    },
    segment_list(state){
        return state.segment_list
    },
    currentNode(state){
        return state.currentNode
    },
    totalQuestion(state){
        let total = 0
        let list = state.assemblyData.segment_list
        list.forEach(one => {
            one.questions.forEach(two=>{
                if(two.question_list){
                    total += two.question_list.length
                }else{
                    total ++
                }
            })
        });
        return total
    },
    activeTest(state){
        if(state.currentNode.length == 0){
            return {}
        }
        let list = state.segment_list[state.currentNode[0]]
        if(state.currentNode.length == 1){
            return list.questions
        }
        if(state.currentNode.length == 2){
            list = list.questions[state.currentNode[1]]
        }
        if(state.currentNode.length == 3){
            list = list.questions[state.currentNode[1]].question_list[state.currentNode[2]]
        }
        return list
    }
}
export default getters


// WEBPACK FOOTER //
// ./packages/question-assembly/store/getters.js